import React, { useContext, useEffect, useState } from "react";
import { Table } from "flowbite-react";
import { useNavigate } from 'react-router-dom';
import { FaArrowRightLong } from "react-icons/fa6";
import Validate from "../shared/validation/Validate";
import axios from "axios";
import Loader from "../shared/Loader/Loader";

const DailyOpeningAndClosing = () => {
    const navigate = useNavigate();


    // user token for API request
    const token = JSON.parse(window.localStorage.getItem("auth"))?.token;

    // userDatail  for API request
    const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;

    const [localCurrency, setLocalCurrency] = useState({});
    const [foreignCurrencies, setForeignCurrencies] = useState([]);
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if(userDetail && userDetail.userRole ==='Admin' && userDetail.shopId === undefined){
            navigate('/shopSelection');
        }
    }, [])

    useEffect(() => {
        const fetchLocalCurrency = async () => {
            try {
                setIsLoading(true)
                const response = await axios.get(process.env.REACT_APP_API_URL + `getLocalBalanceWithTransactions`, {
                    params: {
                        shopId: userDetail?.shopId,
                        date : new Date().toISOString()
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const currency = response.data;

                setLocalCurrency(currency);
                setIsLoading(false)

                // console.log("localCurrencyBalance: ", response)
            } catch (error) {
                console.log(error);
                setIsLoading(false)
            }
        };
        const fetchForeignCurrencies = async () => {
            try {
                setIsLoading(true)
                const response = await axios.get(process.env.REACT_APP_API_URL + `getAllForeignCurrenciesWithTransactions`, {
                    params: {
                        shopId: userDetail?.shopId,
                        date : new Date().toISOString()
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const currencies = response.data.filter(transaction => transaction.fxOut !== 0 || transaction.fxIn !== 0 )

                setForeignCurrencies(currencies);
                setIsLoading(false)
            } catch (error) {
                console.log(error);
                setIsLoading(false)
            }
        };
        fetchLocalCurrency();
        fetchForeignCurrencies();
    }, [])

    return (
        <Validate>
            <div className="">
                {isLoading? <Loader />: ''}
                <div className="">
                    {/* <h1 className="text-headings text-3xl font-medium mt-10">Foreign Currency Balance</h1> */}
                </div>
                <div className="max-h-[500px] overflow-x-auto bg-gray-50 dark:bg-gray-900 rounded-lg shadow-md">
                    <Table className="max-h-[500px]">
                        <Table.Head className="sticky top-0 z-10 bg-theme-secondary">
                            <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg'>Currency</Table.HeadCell>
                            <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg'>Opening Balance</Table.HeadCell>
                            <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg'>FX Buy</Table.HeadCell>
                            <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg'>FX Sell</Table.HeadCell>
                            <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg'>Variance</Table.HeadCell>
                            <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg'>Total Transactions</Table.HeadCell>
                            <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg flex'>Closing Balance</Table.HeadCell>
                        </Table.Head>
                        <Table.Body className={`divide-y `}>
                                <Table.Row className="bg-slate-200  dark:border-gray-700 dark:bg-gray-800">
                                    <Table.Cell className={`whitespace-nowrap font-bold text-lg text-theme-primary flex `}>&nbsp;&nbsp;&nbsp;&nbsp;{localCurrency.currency}<FaArrowRightLong className="mx-1 mt-1" />{localCurrency.country}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{localCurrency.openingAmount}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{localCurrency.fxIn}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{localCurrency.fxOut}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{localCurrency.variance}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{localCurrency.totalTransactions}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{localCurrency.closingAmount}</Table.Cell>
                                </Table.Row>
                        </Table.Body>
                        <Table.Body className="divide-y">
                            {foreignCurrencies.map((val, index) => (
                                <Table.Row key={index} className="bg-slate-200 dark:border-gray-700 dark:bg-gray-800">
                                    <Table.Cell className="whitespace-nowrap font-bold text-lg text-theme-primary flex">&nbsp;&nbsp;&nbsp;&nbsp;{val.currency}<FaArrowRightLong className="mx-1 mt-1" />{val.country}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{val.openingAmount}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{val.fxIn}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{val.fxOut}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{val.variance}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{val.totalTransactions}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{val.closingAmount}</Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </div>
            </div>
        </Validate>
    )
}

export default DailyOpeningAndClosing;




// old one with child components
// import React, { useState } from 'react';
// import { Button, Tabs } from 'flowbite-react';
// import Validate from '../shared/validation/Validate';
// import SellingReportOfDailyOpeningAndClosing from './SellingReportOfDailyOpeningAndClosing';
// import BuyingReportOfDailyOpeningAndClosing from './BuyingReportOfDailyOpeningAndClosing';

// const theme = {
//   "base": "flex flex-col gap-2",
//   "tablist": {
//     "base": "flex text-center",
//     "styles": {
//       "pills": "flex-wrap font-medium text-sm bg-headings pl-3 text-white rounded-lg space-x-2",
//     },
//     "tabitem": {
//       "base": "flex items-center justify-center p-4 rounded-t-lg text-sm font-medium first:ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500",
//       "styles": {
//         "pills": {
//           "base": "",
//           "active": {
//             "on": "rounded-lg bg-white/10 text-white",
//             "off": "rounded-lg hover:bg-white/10"
//           }
//         },
//       },
//       "icon": "mr-2 h-5 w-5"
//     }
//   },
//   "tabitemcontainer": {
//     "base": "",
//     "styles": {
//       "default": "",
//       "underline": "",
//       "pills": "",
//       "fullWidth": ""
//     }
//   },
//   "tabpanel": "py-3"
// }


// function DailyOpeningAndClosing() {

//   return (
//     <Validate >
//       <Tabs aria-label="" theme={theme} style={'pills'} className='w-full'>
//         <Tabs.Item active title="Buying Reports" className='text-xl'>
//           <div className="text-sm text-gray-500 dark:text-gray-400">
//             <BuyingReportOfDailyOpeningAndClosing />
//           </div>
//         </Tabs.Item>
//         <Tabs.Item title="Selling Reports">
//           <div className="text-sm text-gray-500 dark:text-gray-400">
//             <SellingReportOfDailyOpeningAndClosing />
//           </div>
//         </Tabs.Item>
//       </Tabs>
//     </Validate>
//   );
// }

// export default DailyOpeningAndClosing;

